import request from '@/utils/request'
import { Message } from 'element-ui'

// 卖家端 满赠促销活动 列表
export function giftPayeeList(data) {
  return request({
    url: "/product/gift/payee/list",
    method: "get",
    params: data,
  });
}

// 卖家端 满赠促销活动 新增或修改
export function giftPayeeSaveOrUpdate(data) {
  return request({
    url: "/product/gift",
    method: "post",
    data: data,
  });
}

// 卖家端 满赠促销活动  详情
export function giftPayeeDetail(id) {
  return request({
    url: `/product/gift/${id}`,
    method: "get",

  });
}

// /compliance/goodsbase/queryGoodsBasePage
// 查询基库商品列表
export function queryGoodsBasePage(data) {
  return request({
    url: "/product/compliance/goodsbase/queryGoodsBasePage",
    method: "get",
    params: data,
  });
}

// /sales/sku/get/full/gift/page
// 查询满赠商品
export function queryFullGiftPage(data) {
  return request({
    url: "/product/sales/sku/get/full/gift/page",
    method: "get",
    params: data,
  });
}



//满赠活动列表ops
export function giftPayeeListPlatform(data) {
  return request({
    url: "/product/gift/platform/list",
    method: "get",
    params: data,
  });
}


//满赠活动 审核
export function fullGiftAudit(data) {
  return request({
    url: "/product/gift/audit",
    method: "put",
    data: data,
  });
}

// 获取指定用户余额信息
export function getByShopId(data) {
  return request({
    url: `/payment/guarantee/guaranteeCustoms/getByShopId`,
    method: "get",
    params: data,
  });
}

// 翻页列表
export function guaranteeCustomFlowsPage(data) {
  return request({
    url: `/payment/guarantee/guaranteeCustomFlows/page`,
    method: "get",
    params: data,
  });
}

// 平台运营手动增减
export function manualUpdate(data) {
  return request({
    url: `/payment/guarantee/guaranteeCustoms/manualUpdate`,
    method: "post",
    data,
  });
}

// 平台运营商户保证金手动增减
export function manualUpdateCustoms(data) {
  return request({
    url: `/payment/guarantee/platform/manualUpdate`,
    method: "post",
    data,
  });
}
//保证金--- 变动日志列表接口
export function userLogPage(data) {
  return request({
      url: "/payment/guarantee/merchant/ops/userLogPage",
      method: "post",
      data: data,
  });
}

// 保证金详情接口
export function guaranteeInfo(data) {
  return request({
      url: "/payment/guarantee/merchant/info",
      method: "GET",
      params: data,
  });
}

export function fileExport(apiUrl,methodType,data) {
  return request({
      url: apiUrl,
      method:methodType?methodType: "GET",
      data,
      responseType: "blob",
  }).then((response) => {
      // 处理返回的文件流
      const blob = response.data;
      if (blob && blob.size === 0) {
          Message.warning("内容为空，无法下载");
          return;
      }
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      const contentDisposition = response.headers["content-disposition"];
      const fileName = decodeURIComponent(
          contentDisposition.substring(contentDisposition.indexOf("=") + 1)
      );
      // console.log(fileName)
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(function () {
          URL.revokeObjectURL(blob);
          document.body.removeChild(link);
          Message.success("导出成功！");
      }, 0);
  });
}